module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/ques-trade-c50594ec7fdb4dd2b2ef014b24ee5f13.png";